(function () {
  var FALLBACK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhwamp2cmpjam91eWxhcnR1cHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3MzQ3MTEsImV4cCI6MjA2NTMxMDcxMX0.OYbFjEfyO4IspmLKW8W9yqre-46GiqobE22yO7aUvLM';
  var SUPABASE_URL = 'https://xpjjvrjcjouylartupwy.supabase.co';
  var ANON_KEY = '';

  function readMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') || '' : '';
  }

  function readAttribution() {
    var params = new URLSearchParams(window.location.search);
    var attr = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_term: params.get('utm_term'),
      gclid: params.get('gclid'),
      gbraid: params.get('gbraid'),
      wbraid: params.get('wbraid'),
    };
    Object.keys(attr).forEach(function (key) {
      if (!attr[key]) delete attr[key];
    });
    return attr;
  }

  function newEventId() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    return 'ws-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function trackClientLead(program) {
    var category = program === 'pastry' ? 'wholesale_pastry' : 'wholesale_coffee';
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_category: category }, { eventID: newEventId() });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { content_category: category });
    }
  }

  function setMessage(form, text, isError) {
    var msg = form.querySelector('[data-wholesale-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.style.background = isError ? 'rgba(185, 28, 28, 0.15)' : '';
    msg.style.borderColor = isError ? 'rgba(185, 28, 28, 0.45)' : '';
  }

  function resolveAnonKey(form) {
    return (
      form.getAttribute('data-supabase-anon-key') ||
      document.body.getAttribute('data-supabase-anon-key') ||
      ANON_KEY ||
      readMeta('supabase-anon-key') || FALLBACK_ANON_KEY
    );
  }

  function bindForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var anon = resolveAnonKey(form);
      if (!anon) {
        setMessage(form, 'Configuration error — please call (615) 613-4880 or email wholesale@blackelm.coffee.', true);
        return;
      }

      var submitBtn = form.querySelector('[type="submit"]');
      var program = form.getAttribute('data-program') || 'coffee';
      var businessName = (form.querySelector('[name="business_name"]') || {}).value || '';
      var contactName = (form.querySelector('[name="contact_name"]') || {}).value || '';
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var phone = (form.querySelector('[name="phone"]') || {}).value || '';
      var businessType = (form.querySelector('[name="business_type"]') || {}).value || '';
      var volume = (form.querySelector('[name="estimated_monthly_volume"]') || {}).value || '';
      var message = (form.querySelector('[name="message"]') || {}).value || '';

      if (!String(businessName).trim() || !String(email).trim()) {
        setMessage(form, 'Please enter your business name and email.', true);
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }

      var clientEventId = newEventId();
      trackClientLead(program);

      fetch(SUPABASE_URL + '/functions/v1/wholesale-inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + anon,
          apikey: anon,
        },
        body: JSON.stringify({
          business_name: String(businessName).trim(),
          contact_name: String(contactName).trim(),
          email: String(email).trim(),
          phone: String(phone).trim(),
          business_type: businessType,
          estimated_monthly_volume: volume,
          message: String(message).trim(),
          program: program,
          landing_page: window.location.href,
          client_event_id: clientEventId,
          attribution: readAttribution(),
        }),
      })
        .then(function (resp) {
          return resp.json().then(function (data) {
            return { ok: resp.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.success) {
            throw new Error((result.data && result.data.error) || 'submit_failed');
          }
          setMessage(
            form,
            'Thanks — we received your inquiry. Our wholesale team will follow up within one business day with pricing and next steps.',
            false
          );
          form.reset();
        })
        .catch(function () {
          setMessage(
            form,
            'Something went wrong submitting your request. Please email wholesale@blackelm.coffee or call (615) 613-4880.',
            true
          );
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-default-label') || 'Request price list';
          }
        });
    });
  }

  function init() {
    ANON_KEY = readMeta('supabase-anon-key') || FALLBACK_ANON_KEY;
    document.querySelectorAll('[data-wholesale-lead-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
